import type { FC } from "react"

import type { RoofEdgeType } from "@logic/lib/design"
import { ROOF_EDGE_TYPES } from "@logic/lib/design"
import { css } from "styled-components"

import { Radio } from "~/components/ui"
import { fontWeight } from "~/utils/styles"

import { ReactComponent as eave } from "@svg/edges/eave.svg"
import { ReactComponent as hip } from "@svg/edges/hip.svg"
import { ReactComponent as rake } from "@svg/edges/rake.svg"
import { ReactComponent as ridge } from "@svg/edges/ridge.svg"
import { ReactComponent as valley } from "@svg/edges/valley.svg"

import { edgeDesignationState } from "../../state/tool/edgeDesignation"
import { EDGE_APPEARANCES } from "../../Studio/Elements/STROKES"

export const radioCss = css`
  display: inline-flex;
  flex-shrink: 0;
  flex-grow: 1;
  flex-flow: column;
  padding: 10px 0;
  width: 100%;

  label[data-role="main"] {
    text-transform: capitalize;
    padding: 10px;
    font-size: var(--step--1);
    font-weight: 600;
  }
  label[data-role="option"] {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 100%;
    height: 70px;
    cursor: pointer;
    span {
      font-size: var(--step--2);
      text-transform: capitalize;
    }
    span[data-role="option-name"] {
      display: none;
    }
    [data-role="panel"] {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      svg {
        width: 50px;
        height: 50px;
        background-color: white;
        border: 2px solid var(--grey-border);
        box-sizing: border-box;
      }
    }
    input[type="radio" i] {
      border: none;
      position: relative;
      height: 0px;
      width: 0px;
      cursor: default;
      appearance: unset;
      box-sizing: border-box;
      outline: none;
      &:checked {
        border-color: var(--grey-dark);
        &::before {
          content: "";
          position: absolute;
          top: 4px;
          left: 4px;
          bottom: 4px;
          right: 4px;
          background: var(--blue);
        }
        ~ [data-role="option-name"] {
          color: var(--blue);
          ${fontWeight(600)}
        }
        ~ [data-role="panel"] {
          background: #e0eeff;
        }
      }
      /* &:disabled {
        ~ [data-role="panel"] svg * {
          fill: #ccc;
        }
      } */
    }
  }
`

export const EDGE_ICONS: Record<RoofEdgeType, FC> = {
  eave,
  hip,
  rake,
  ridge,
  valley,
}

export const EdgeDesignator: FC = () => (
  <Radio
    label="Edge Type"
    state={edgeDesignationState}
    options={ROOF_EDGE_TYPES}
    icon={{
      get: (type: RoofEdgeType) => EDGE_ICONS[type],
      props: (type) => ({
        active: { style: { borderColor: EDGE_APPEARANCES[type].color } },
      }),
    }}
    css={radioCss}
  />
)
